import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toastr } from 'react-redux-toastr';
import { Button } from 'reactstrap';
import {
  getItineraryJson,
  getSenderRemissionGuidePDFByItineraryV2,
} from '../../../../../actions';
import printSenderRemissionGuide from '../../../../../utils/printers/SenderRemissionGuide';

const PrintSenderRemissionGuideButton = ({
  itineraryId,
  dispatchGetSenderRemissionGuidePDFByItineraryV2,
  dispatchGetItineraryJson,
}) => {
  const onPrintCarrierRemissionGuide = async () => {
    let carrierRemissionGuideList = null;
    const itineraryJson = await dispatchGetItineraryJson({ itineraryId });

    carrierRemissionGuideList =
      await dispatchGetSenderRemissionGuidePDFByItineraryV2(itineraryId);

    if (carrierRemissionGuideList.length !== 0) {
      printSenderRemissionGuide(itineraryJson, carrierRemissionGuideList);
    } else {
      toastr.error(
        'Error',
        'El itinerario no tiene guías de remisión remitentess emitidas',
      );
    }
  };

  return (
    <Button
      color="light"
      className="border"
      onClick={onPrintCarrierRemissionGuide}
    >
      <i className="fa fa-print" /> Imprimir GRR
    </Button>
  );
};

const mapStateToProps = (state) => ({
  billings: state.AccountingUnit.Billing.getIn(['all', 'content']),
});

PrintSenderRemissionGuideButton.propTypes = {
  itineraryId: PropTypes.string.isRequired,
  dispatchGetSenderRemissionGuidePDFByItineraryV2: PropTypes.func.isRequired,
  dispatchGetItineraryJson: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchGetSenderRemissionGuidePDFByItineraryV2:
    getSenderRemissionGuidePDFByItineraryV2,
  dispatchGetItineraryJson: getItineraryJson,
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrintSenderRemissionGuideButton);

export default connectedComponent;
